<template>
    <div
        :class="[$style.header, isSearchOpened && $style.header_search_opened]"
        data-interface-section="mobile-header"
    >
        <MobileSearch
            @open="isSearchOpened = true"
            @close="isSearchOpened = false"
        />
        <template v-if="!isSearchOpened">
            <Link
                :to="{ name: ROUTE_NAMES.MAIN }"
                data-interface-target="logo-link"
                :class="$style.logo_link"
            >
                <Logo
                    :class="$style.logo_override"
                    mode="default"
                />
            </Link>
            <template v-if="userInfoLoaded">
                <MobileNoAdButton />
                <NoAdActiveBadge />
                <YoutubeButton />
                <UserWidget
                    v-if="user"
                    :user
                />
                <Button
                    v-else
                    size="l"
                    color="lime"
                    interfaceTarget="open-sign-in-modal"
                    :label="$tr('header.login')"
                    :class="$style.login_button_override"
                    @click="signin"
                />
            </template>
        </template>
    </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { ref } from 'vue'

import Button from '@/components/Buttons/Button.vue'
import MobileNoAdButton from '@/components/Headers/components/MobileNoAdButton.vue'
import NoAdActiveBadge from '@/components/Headers/components/NoAdActiveBadge.vue'
import UserWidget from '@/components/Headers/components/UserWidget.vue'
import YoutubeButton from '@/components/Headers/components/YoutubeButton.vue'
import Link from '@/components/Link.vue'
import Logo from '@/components/Logo.vue'
import MobileSearch from '@/components/Search/MobileSearch.vue'
import { useUserInfoLoaded } from '@/composables/use-user-state'
import { ROUTE_NAMES } from '@/router/constants'
import { useLayoutStore } from '@/store/layout-store'
import { useUserStore } from '@/store/user-store/user-store'

const userStore = useUserStore()
const layoutStore = useLayoutStore()

const { user } = storeToRefs(userStore)
const userInfoLoaded = useUserInfoLoaded()

const isSearchOpened = ref(false)

function signin() {
    layoutStore.openSignInModal('mobile-header')
}
</script>

<style module>
.header {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 6px 0 12px;
    gap: 4px;
}

.header:not(.header_search_opened) {
    position: sticky;
    top: var(--pg-safe-area-top);
    z-index: 1;
}

.logo_link {
    box-sizing: border-box;
    height: 48px;
    border-radius: 1000px;
    background: var(--purple-400);
    display: flex;
    align-items: center;
    padding: 0 clamp(8px, 3vw, 14px);
    box-shadow: inset 0 0 0 1px var(--white-25);
}

.logo_override {
    width: 115px;
    color: var(--white);
}

.login_button_override::before {
    box-shadow: inset 0 0 0 1px var(--white-25);
}
</style>
